import * as React from "react"
import cx from "classnames"

import * as styles from "./styles.module.scss"

export interface BackProps {
  previousCallback: any
}

const Back: React.FC<BackProps> = ({ previousCallback }) => {
  return (
    <button
      className={styles.button}
      onTouchStart={() => {
        return true
      }}
      onClick={previousCallback}
    >
      <i
        className={cx({
          [styles.icon]: true,
          ["bsk-icon-arrow-stick-right-thicker"]: true,
        })}
      ></i>
      <span className={styles.underline}>Back</span>
    </button>
  )
}

export default Back
